// src/Routes/router.jsx
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Login from "../Pages/AuthPages/Login/Login";
import Dashboard from "../Pages/DashBoard/Dashboard";
import PageNotFound from "../Exceptions/PageNotFound";
import RouteProtector from "./Layouts/IndexPageLayout";
import ForgotPassword from "../Pages/AuthPages/Forgot_Password/ForgotPassword";
import ResetPassword from "../Pages/AuthPages/Reset_Password/ResetPassword";
import Users from "../Pages/Users/Users";
import MyTasks from "../Pages/Tasks/MyTasks";
import Features from "../Components/Footer/Features";
import Pricing from "../Components/Footer/Pricing";
import Faq from "../Components/Footer/Faq";
import Terms from "../Components/Footer/Terms";
import Privacy from "../Components/Footer/Privacy";
import Cookies from "../Components/Footer/Cookies";
import Support from "../Components/Footer/Support";
import SystemStatus from "../Components/Footer/SystemStatus";
import Attendance from "../Pages/Attendance/Attendance";
import ChangePassword from "../Pages/Settings/ChangePassword";
import UpdateCredentials from "../Pages/Settings/UpdateCredentials";
import Organisation from "../Pages/Orgnaization/Organisation/Organisation";
import OrganizationProfile from "../Pages/Orgnaization/Profile/OrganizationProfile";
import BusinessDivisionForm from "../Pages/Business/Divisions/BusinessDivisionsForm";
import BusinessRegistrationsForm from "../Pages/Orgnaization/Registrations/OrganizationRegistrationsForm";
import OrganizationLocationForm from "../Pages/Orgnaization/Location/OrganizationLocationForm";
import BusinessUnitForm from "../Pages/Business/Unit/BusinessUnitForm";
import OrganizationLocationList from "../Pages/Orgnaization/Location/OrganizationLocationList";
import BusinessDivisionsList from "../Pages/Business/Divisions/BusinessDivisionsList";
import CoverLayout from "../Pages/DataLayouts/CoverLayout";
import BusinessRegistrationsList from "../Pages/Orgnaization/Registrations/OrganizationRegistrationsList";
import BusinessUnitList from "../Pages/Business/Unit/BusinessUnitList";
import { Configurations } from "../Pages/OptmisedCode/FormConfigurations";
import OrganizationDepartmentForm from "../Pages/Orgnaization/Department/OrganizationDepartmentsForm";
import OrganizationDepartmentsList from "../Pages/Orgnaization/Department/OrganizationDepartmentsList";
import OrganizationDepartmentsLocationList from "../Pages/Departments/Locations/OrganizationDepartmentsLocationList";
import OrganizationDepartmentLocationsForm from "../Pages/Departments/Locations/OrganizationDepartmentLocationsForm";
import UsersAdd from "../Pages/Users/UsersAdd";
import UsersEdit from "../Pages/Users/UserEdit";
import OrganizationEmployementExitReasonsList from "../Pages/OrganizationConfigration/ExitReasons/OrganizationEmployementExitReasonsList";
import OrganizationEmployementExitReasonsForm from "../Pages/OrganizationConfigration/ExitReasons/OrganizationEmployementExitReasonsForm";
import OrganizationEmployementTypesForm from "../Pages/OrganizationConfigration/Types/OrganizationEmployementTypesForm";
import OrganizationEmployementStatusesList from "../Pages/OrganizationConfigration/Statuses/OrganizationEmployementStatusesList";
import OrganizationEmployementStatusesForm from "../Pages/OrganizationConfigration/Statuses/OrganizationEmployementStatusesForm";
import OrganizationEmployementTypesList from "../Pages/OrganizationConfigration/Types/OrganizationEmployementTypesList";
import OrganizationEmployeeAddressTypeForm from "../Pages/OrganizationConfigration/AddressType/OrganizationEmployeeAddressTypeForm";
import OrganizationEmployeeAddressTypeList from "../Pages/OrganizationConfigration/AddressType/OrganizationEmployeeAddressTypeList";
import HolidayCalendarForm from "../Pages/LeaveManagement/Holiday-Calendar/HolidayCalendarForm";
import HolidayCalendarList from "../Pages/LeaveManagement/Holiday-Calendar/HolidayCalendarList";
import HolidayTypesList from "../Pages/OrganizationConfigration/HolidayTypes/HolidayTypesList";
import HolidayTypesForm from "../Pages/OrganizationConfigration/HolidayTypes/HolidayTypesForm";
import HolidayList from "../Pages/Holidays/Holiday'/HolidayList";
import HolidayForm from "../Pages/Holidays/Holiday'/HolidayForm";
import LeaveCategoryList from "../Pages/OrganizationConfigration/LeaveCategory/LeaveCategoryList";
import LeaveCategoryForm from "../Pages/OrganizationConfigration/LeaveCategory/LeaveCategoryForm";
import LeaveTypeList from "../Pages/OrganizationConfigration/LeaveType/LeaveTypeList";
import LeaveTypeForm from "../Pages/OrganizationConfigration/LeaveType/LeaveTypeForm";
import LeaveReasonList from "../Pages/OrganizationConfigration/LeaveReason/LeaveReasonList";
import LeaveReasonForm from "../Pages/OrganizationConfigration/LeaveReason/LeaveReasonForm";
import MyProfile from "../Pages/MyProfile/MyProfilePage";
import EmployeeList from "../Pages/EmployeeManagement/Employees/EmployeesList";
import EmployeeForm from "../Pages/EmployeeManagement/Employees/EmployeesForm";
import EmployeeAddressList from "../Pages/EmployeeManagement/EmployeeAddress/EmployeeAddressList";
import EmployeeAddressForm from "../Pages/EmployeeManagement/EmployeeAddress/EmployeeAddressForm";
import EmployeeExitList from "../Pages/EmployeeManagement/EmployeeExits/EmployeeExitList";
import EmployeeExitForm from "../Pages/EmployeeManagement/EmployeeExits/EmployeeExitForm";
import EmployeeLeaveList from "../Pages/LeaveManagement/EmployeeLeaves/EmployeeLeaveList";
import EmployeeLeaveForm from "../Pages/LeaveManagement/EmployeeLeaves/EmployeeLeaveForm";
import EmployeeContactList from "../Pages/EmployeeManagement/EmployeeContactDetails/EmployeeContactList";
import EmployeeContactForm from "../Pages/EmployeeManagement/EmployeeContactDetails/EmployeeContactForm";
import UserRoleList from "../Pages/User Management/UserRoles/UserRoleList";
import UserRoleForm from "../Pages/User Management/UserRoles/UserRoleForm";
import UserModuleList from "../Pages/ApplicationManagement/UserModules/UserModuleList";
import UserModuleForm from "../Pages/ApplicationManagement/UserModules/UserModulesForm";
import UserList from "../Pages/User Management/User/UserList";
import UserForm from "../Pages/User Management/User/UserForm";
import ApplicationErrorLogList from "../Pages/ApplicationManagement/ApplicationErrorLogs/ApplicationErrorLogList";
import ApplicationErrorLogForm from "../Pages/ApplicationManagement/ApplicationErrorLogs/ApplicationErrorLogForm";
import RoleAssignmentList from "../Pages/User Management/RoleAssignment/RoleAssignmentList";
import RoleAssignmentForm from "../Pages/User Management/RoleAssignment/RoleAssignmentForm";
import FreeTrialPage from "../Pages/AuthPages/FreeTrailPage/TrialPage";
import OtpVerify from "../Pages/AuthPages/OtpVerify/OtpVerify";
import OrganizationDetails from "../Pages/SignUpPages/OrganizationDetails";
import OrganizationUnitList from "../Pages/Orgnaization/Units/OrganizationUnitList";
import OrganizationUnitForms from "../Pages/Orgnaization/Units/OrganizationUnitForm";
import OrganizationDesignationsForm from "../Pages/Orgnaization/Designations/OrganizationDesignationsForm";
import OrganizationDesignationsList from "../Pages/Orgnaization/Designations/OrganizationDesignationsList";
import RecruitmentSourcesList from "../Pages/Orgnaization/RecruitmentSources/RecruitmentSourcesList";
import RecruitmentSourcesForm from "../Pages/Orgnaization/RecruitmentSources/RecruitmentSourcesForm";
import RecruitmentSourceTypesList from "../Pages/Orgnaization/RecruitmentSources/RecruitmentSourceTypesList";
import RecruitmentSourceTypesForm from "../Pages/Orgnaization/RecruitmentSources/RecruitmentSourceTypesForm";
import RecruitmentSourceContactsList from "../Pages/Orgnaization/RecruitmentSources/RecruitmentSourceContactsList";
import RecruitmentSourceContactsForm from "../Pages/Orgnaization/RecruitmentSources/RecruitmentSourceContactsForm";
import RecruitmentOpeningsList from "../Pages/Orgnaization/RecruitmentOpenings/RecruitmentOpeningsList";
import RecruitmentOpeningsForm from "../Pages/Orgnaization/RecruitmentOpenings/RecruitmentOpeningsForm";
import RecruitmentApplicationsList from "../Pages/Orgnaization/RecruitmentApplications/RecruitmentApplicationsList";
import RecruitmentApplicationsForm from "../Pages/Orgnaization/RecruitmentApplications/RecruitmentApplicationsForm";
import OrganizationRegistrationsForm from "../Pages/Orgnaization/Registrations/OrganizationRegistrationsForm";
import OrganizationRegistrationsList from "../Pages/Orgnaization/Registrations/OrganizationRegistrationsList";
import BusinessOwnershipTypeForm from "../Pages/OrganizationConfigration/BusinessOwnershipTypes/BusinessOwnershipTypeForm";
import BusinessOwnershipTypeList from "../Pages/OrganizationConfigration/BusinessOwnershipTypes/BusinessOwnershipTypeList";
import BusinessRegistrationTypeForm from "../Pages/OrganizationConfigration/BusinessRegistrationType/BusinessRegistrationTypeForm";
import BusinessRegistrationTypeList from "../Pages/OrganizationConfigration/BusinessRegistrationType/BusinessRegistrationTypeList";
import BusinessUnitTypeForm from "../Pages/OrganizationConfigration/BusinessUnitsTypes/BusinessUnitTypeForm";
import BusinessUnitTypeList from "../Pages/OrganizationConfigration/BusinessUnitsTypes/BusinessUnitTypeList";
import ResidentialOwnershipTypeForm from "../Pages/OrganizationConfigration/ResidentialOwnershipType/ResidentialOwnershipTypeForm";
import ResidentialOwnershipTypeList from "../Pages/OrganizationConfigration/ResidentialOwnershipType/ResidentialOwnershipTypeList";
import LocationOwnershipTypeList from "../Pages/OrganizationConfigration/LocationOwnershipTypes/LocationOwnershipTypeList";
import LocationOwnershipTypeForm from "../Pages/OrganizationConfigration/LocationOwnershipTypes/LocationOwnershipTypeForm";
import OrganizationEmployementExitReasonTypeForm from "../Pages/OrganizationConfigration/ExitReasonType/OrganizationEmployementExitReasonTypeForm";
import OrganizationEmployementExitReasonTypeList from "../Pages/OrganizationConfigration/ExitReasonType/OrganizationEmployementExitReasonTypeList";
import LeaveReasonTypeList from "../Pages/OrganizationConfigration/LeaveReasonType/LeaveReasonTypeList";
import LeaveReasonTypeForm from "../Pages/OrganizationConfigration/LeaveReasonType/LeaveReasonTypeForm";
import WorkModelList from "../Pages/OrganizationConfigration/WorKModel/WorkModelList";
import WorkModelForm from "../Pages/OrganizationConfigration/WorKModel/WorkModelFormForm";
import UserTypeList from "../Pages/OrganizationConfigration/UserTypes/UserTypeList";
import UserTypeForm from "../Pages/OrganizationConfigration/UserTypes/UserTypeForm";
import WorkShiftList from "../Pages/Time & Attendence/WorkShifts/WorkShiftList";
import WorkShiftForm from "../Pages/Time & Attendence/WorkShifts/WorkShiftForm";
import WorkShiftTypeForm from "../Pages/OrganizationConfigration/WorkShiftTypes/WorkShiftTypeForm";
import WorkShiftTypeList from "../Pages/OrganizationConfigration/WorkShiftTypes/WorkShiftTypeList";
import SystemModulesForm from "../Pages/SystemModules/System Modules/SystemModulesForm";
import SystemModulesList from "../Pages/SystemModules/System Modules/SystemModulesList";
import ModuleActionList from "../Pages/SystemModules/ModuleAction/ModuleActionList";
import ModuleActionForm from "../Pages/SystemModules/ModuleAction/ModuleActionForm";
import SettingTypeForm from "../Pages/SystemModules/SettingTypes/SettingTypeForm";
import SettingTypeList from "../Pages/SystemModules/SettingTypes/SettingTypeList";
import SettingList from "../Pages/SystemModules/Settings/SettingList";
import SettingForm from "../Pages/SystemModules/Settings/SettingForm";
import OrganizationAddInList from "../Pages/Orgnaization/Organisation/OrganizationAddInList";
import OrganizationAddInForm from "../Pages/Orgnaization/Organisation/OrganizationAddInForm";
import OrganizationApplicationAccess from "../Pages/Orgnaization/Organisation/OrganizationApplicationAccess";
import DynamicFormPage from "../Pages/DataLayouts/DynamicFormPage";
import OrganizationLanguageList from "../Pages/OrganizationConfigration/Languages/OrganizationLanguageList";
import OrganizationLanguageForm from "../Pages/OrganizationConfigration/Languages/OrganizationLanguageForm";
import RolePermissionList from "../Pages/User Management/RolePermission/RolePermissionList";
import RolePermissionForm from "../Pages/User Management/RolePermission/RolePermissionForm";
import ViewRolePermissionForm from "../Pages/User Management/RolePermission/ViewRolePermissionForm";
import PermissionGate from "./PermissionGate";
import PersonalizationModal from "../Pages/DashBoard/PersonalizationModal";
import EmployeesForm from "../Pages/EmployeeManagement/Employees/EmployeesForm";
import EmployeeLeaveEntitlementList from "../Pages/LeaveManagement/EmployeeLeaveEntitlement/EmployeeLeaveEntitlementList";
import EmployeeLeaveEntitlmentForm from "../Pages/LeaveManagement/EmployeeLeaveEntitlement/EmployeeLeaveEntitlmentForm";
import FaceAuth from "../Pages/Time & Attendence/WorkShifts/FaceAuth";

import LevaeBalanceReportList from "../Pages/LeaveManagement/LeaveBalanceReport/LevaeBalanceReportList";
import LeaveSummaryMonthlyReport from "../Pages/LeaveManagement/LevaeSummaryReport/LevaeSummaryMonthlyReportList";
import AttendenceStatusTypeList from "../Pages/AttendenceRecord/AttendenceStatusType/AttendenceStatusTypeList";
import AttendenceStatusTypeForm from "../Pages/AttendenceRecord/AttendenceStatusType/AttendenceStatusTypeForm";
import AttendenceSourceList from "../Pages/AttendenceRecord/AttendenceSource/AttendenceSourceList";
import AttendenceSourceForm from "../Pages/AttendenceRecord/AttendenceSource/AttendenceSourceForm";
import AttendenceDeviationReasonTypeForm from "../Pages/AttendenceRecord/AttendanceDeiationReasonType/AttendenceDeviationReasonTypeForm";
import AttendenceDeviationReasonTypeList from "../Pages/AttendenceRecord/AttendanceDeiationReasonType/AttendenceDeviationReasonTypeList";
import AttendanceDeviationReasonList from "../Pages/AttendenceRecord/AttendanceDeviationReason/AttendanceDeviationReasonList";
import AttendanceDeviationReasonForm from "../Pages/AttendenceRecord/AttendanceDeviationReason/AttendanceDeviationReasonForm";
import AttendenceBreakTypesList from "../Pages/AttendenceRecord/AttendenceBreakType/AttendenceBreakTypesList";
import AttendenceBreakTypesForm from "../Pages/AttendenceRecord/AttendenceBreakType/AttendenceBreakTypesForm";
import AttendanceRecordList from "../Pages/AttendenceRecord/AttendanceRecord/AttendanceRecordList";
import AttendanceRecordForm from "../Pages/AttendenceRecord/AttendanceRecord/AttendanceRecordForm";
import AttendanceTimelogsList from "../Pages/AttendenceRecord/AttendanceTimelogs/AttendanceTimelogsList";
import AttendanceTimelogsForm from "../Pages/AttendenceRecord/AttendanceTimelogs/AttendanceTimelogsForm";
import AttendanceDeviationRecordList from "../Pages/AttendenceRecord/AttendanceDeviationRecord/AttendanceDeviationRecordList";
import AttendanceDeviationRecordForm from "../Pages/AttendenceRecord/AttendanceDeviationRecord/AttendanceDeviationRecordForm";
import CustomisetableReport from "../Components/Table/CustomisetableReport";
import RecordWithoutBreakList from "../Pages/AttendenceRecord/AttendanceReportDailyWithoutBreak/RecordWithoutBreakList";

import AttendanceBreakList from "../Pages/Orgnaization/AttendanceBreaks/AttendanceBreakList";
import AttendanceBreakForm from "../Pages/Orgnaization/AttendanceBreaks/AttendanceBreakForm";
import AttendanceMonthlyReportList from "../Pages/AttendenceRecord/AttendanceMonthlyReport/AttendanceMonthlyReportList";
import EmployeeMonthlyAttendanceReportList from "../Pages/AttendenceRecord/AttendanceMonthlyReport/EmployeeMonthlyAttendanceReportList";
import InternMonthlyAttendanceReportList from "../Pages/AttendenceRecord/AttendanceMonthlyReport/InternMonthlyAttendanceReportList";
import WorkshiftBreakForm from "../Pages/Orgnaization/WorkShiftBreaks/WorkshiftBreakForm";
import WorkshiftBreakList from "../Pages/Orgnaization/WorkShiftBreaks/WorkshiftBreakList";
import WorkshiftAssignmentList from "../Pages/Time & Attendence/WorkShiftAssignment/WorkShiftAssignmentList";
import WorkshiftAssignmentForm from "../Pages/Time & Attendence/WorkShiftAssignment/WorkShiftAssignmentForm";
import WorkShiftRotationPatternList from "../Pages/Time & Attendence/WorkShiftRotationPattern/WorkShiftRotationPatternList";
import WorkShiftRotationPatternForm from "../Pages/Time & Attendence/WorkShiftRotationPattern/WorkShiftRotationPatternForm";
import WorkShiftRotationDayList from "../Pages/Time & Attendence/WorkShiftRotationDays/WorkShiftRotationDayList";
import WorkShiftRotationDayForm from "../Pages/Time & Attendence/WorkShiftRotationDays/WorkShiftRotationDayForm";
import WorkShiftRotationAssignmentForm from "../Pages/Time & Attendence/WorkShiftRotationAssigment/WorkShiftRotationAssigmentForm";
import WorkShiftRotationAssignmentList from "../Pages/Time & Attendence/WorkShiftRotationAssigment/WorkShiftRotationAssigmentList";
import LeavePolicyList from "../Pages/Orgnaization/LeavePolicies/LeavePolicyList";
import LeavePolicyForm from "../Pages/Orgnaization/LeavePolicies/LeavePolicyForm";
import SalaryIncrementTypesList from "../Pages/SalaryGrowth/IncrementTypes/SalaryIncrementTypesList";
import SalaryIncrementTypesForm from "../Pages/SalaryGrowth/IncrementTypes/SalaryIncrementTypesForm";
import IncrementList from "../Pages/SalaryGrowth/Increments/IncrementList";
import IncrementForm from "../Pages/SalaryGrowth/Increments/IncrementForm";
import EmployeeRecordList from "../Pages/EmployeeManagement/EmployeeRecord/EmployeeRecordList";
import EmployeeRecordForm from "../Pages/EmployeeManagement/EmployeeRecord/EmployeeRecordForm";
import ComponentTypesList from "../Pages/Payroll System/ComponentTypes/ComponentTypesList";
import ComponentTypesForm from "../Pages/Payroll System/ComponentTypes/ComponentTypesForm";
import ComponentList from "../Pages/Payroll System/Components/ComponentList";
import ComponentForm from "../Pages/Payroll System/Components/ComponentForm";
import PayrollSlabsList from "../Pages/Payroll System/PayrollSlabs/PayrollSlabsList";
import PayrollSlabsForm from "../Pages/Payroll System/PayrollSlabs/PayrollSlabsForm";
import PayrollCycleList from "../Pages/Payroll System/PayrollCycle/PayrollCycleList";
import PayrollCycleForm from "../Pages/Payroll System/PayrollCycle/PayrollCycleForm";
import SalaryStructureList from "../Pages/Payroll System/SalaryStructure/SalaryStructureList";
import SalaryStructureForm from "../Pages/Payroll System/SalaryStructure/SalaryStructureForm";
import SalaryStructureComponentList from "../Pages/Payroll System/SalaryStructureComponent/SalaryStructureComponentList";
import SalaryStructureComponentForm from "../Pages/Payroll System/SalaryStructureComponent/SalaryStructureComponentForm";
import AdvancePayrollList from "../Pages/Payroll System/PayrollAdvances/AdvancePayrollList";
import AdvancePayrollForm from "../Pages/Payroll System/PayrollAdvances/AdvancePayrollForm";
import PayrollLoanTypesList from "../Pages/Payroll System/PayrollLoanTypes/PayrollLoanTypesList";
import PayrollLoanTypesForm from "../Pages/Payroll System/PayrollLoanTypes/PayrollLoanTypesForm";
import PayrollLoanList from "../Pages/Payroll System/PayrollLoans/PayrollLoanList";
import PayrollLoanForm from "../Pages/Payroll System/PayrollLoans/PayrollLoanForm";
import PayrollLoanTransactionForm from "../Pages/Payroll System/PayrollLoanTransaction/PayrollLoanTransactionForm";
import PayrollLoanTransactionList from "../Pages/Payroll System/PayrollLoanTransaction/PayrollLoanTransactionList";
import PayrollSecurityList from "../Pages/Payroll System/PayrollSecurities/PayrollSecurityList";
import PayrollSecurityForm from "../Pages/Payroll System/PayrollSecurities/PayrollSecurityForm";
import PayrollSecurityTransactionForm from "../Pages/Payroll System/PayrollSecurityTransaction/PayrollSecurityTransactionForm";
import PayrollSecurityTransactionList from "../Pages/Payroll System/PayrollSecurityTransaction/PayrollSecurityTransactionList";
import PayrollRunList from "../Pages/Payroll System/PayrollRuns/PayrollRunList";
import PayrollRunForm from "../Pages/Payroll System/PayrollRuns/PayrollRunForm";
import PayrollRunEmployeeForm from "../Pages/Payroll System/PayrollRunEmployees/PayrollRunEmployeeForm";
import PayrollRunEmployeeList from "../Pages/Payroll System/PayrollRunEmployees/PayrollRunEmployeeList";
import PayrollRunEmployeeComponentForm from "../Pages/Payroll System/PayrollRunEmployeeComponent/PayrollRunEmployeeComponentForm";
import PayrollRunEmployeeComponentList from "../Pages/Payroll System/PayrollRunEmployeeComponent/PayrollRunEmployeeComponentList";
import PayrollPeriodForm from "../Pages/Payroll System/PayrollPeriods/PayrollPeriodForm";
import PayrollPeriodList from "../Pages/Payroll System/PayrollPeriods/PayrollPeriodList";
import PayslipPaymentList from "../Pages/Payroll System/PayslipPayments/PayslipPaymentList";
import PayslipPaymentForm from "../Pages/Payroll System/PayslipPayments/PayslipPaymentForm";
import EmployeePayslipComponentForm from "../Pages/Payroll System/EmployeePayslipComponent/EmployeePayslipComponentForm";
import EmployeePayslipComponentList from "../Pages/Payroll System/EmployeePayslipComponent/EmployeePayslipComponentList";
import PayrollReimbursementTypeList from "../Pages/Payroll System/PayrollReimbursementTypes/PayrollReimbursementTypeList";
import PayrollReimbursementTypeForm from "../Pages/Payroll System/PayrollReimbursementTypes/PayrollReimbursementTypeForm";
import PayrollReimbursementList from "../Pages/Payroll System/PayrollReimbursement/PayrollReimbursementList";
import PayrollReimbursementForm from "../Pages/Payroll System/PayrollReimbursement/PayrollReimbursementForm";
import PayrollAdjustmentTypeForm from "../Pages/Payroll System/PayrollAdjustmentTypes/PayrollAdjustmentTypeForm";
import PayrollAdjustmentTypeList from "../Pages/Payroll System/PayrollAdjustmentTypes/PayrollAdjustmentTypeList";
import PayrollAdjustmentList from "../Pages/Payroll System/PayrollAdjustments/PayrollAdjustmentList";
import PayrollAdjustmentForm from "../Pages/Payroll System/PayrollAdjustments/PayrollAdjustmentForm";
import PayrollJourneyEntriesForm from "../Pages/Payroll System/PayrollJournalEntries/PayrollJourneyEntriesForm";
import PayrollJourneyEntriesList from "../Pages/Payroll System/PayrollJournalEntries/PayrollJourneyEntriesList";
import PayrollAccountMappingList from "../Pages/Payroll System/PayrollAccountMapping/PayrollAccountMappingList";
import PayrollAccountMappingForm from "../Pages/Payroll System/PayrollAccountMapping/PayrollAccountMappingForm";
import DocumentLinkList from "../Pages/DocumentRecord/Links/DocumentLinkList";
import DocumentLinkForm from "../Pages/DocumentRecord/Links/DocumentLinkForm";
import Documentist from "../Pages/DocumentRecord/Documents/Documentist";
import DocumentForm from "../Pages/DocumentRecord/Documents/DocumentForm";
import DocumentTypesForm from "../Pages/DocumentRecord/Types/DocumentTypesForm";
import DocumentTypesList from "../Pages/DocumentRecord/Types/DocumentTypesList";
import EmployeeProfile from "../Pages/EmployeeManagement/Employees/EmployeeProfile";
import IntershipTypesForm from "../Pages/InternManagement/InternshipTypes/IntershipTypesForm";
import IntershipTypesList from "../Pages/InternManagement/InternshipTypes/IntershipTypesList";
import IntershipStatusForm from "../Pages/InternManagement/Status/IntershipStatusForm";
import DynamicFormInternPage from "../Pages/DataLayoutIntern/DynamicFormInternPage";
import InternList from "../Pages/InternManagement/Interns/InternList";
import MultiTableConfig from "../Pages/TableConfigForm/MultiTableConfig";
import InterExitRecordList from "../Pages/InternManagement/InterExitRecord/InterExitRecordList";
import InterExitRecordForm from "../Pages/InternManagement/InterExitRecord/InterExitRecordForm";
import InternLeaveForm from "../Pages/InternManagement/InternLeaves/InternLeaveForm";
import InternLeaveList from "../Pages/InternManagement/InternLeaves/InternLeaveList";
import InternDocumentTypeList from "../Pages/InternManagement/InternDocumentTypes/InternDocumentTypeList";
import InternDocumentTypeForm from "../Pages/InternManagement/InternDocumentTypes/InternDocumentTypeForm";
import InternStipendList from "../Pages/InternManagement/InternStipend/InternStipendList";
import InternStipendForm from "../Pages/InternManagement/InternStipend/InternStipendForm";
import InternAttendanceTimelogsForm from "../Pages/InternManagement/InternAttendanceTimelogs/InternAttendanceTimelogsForm";
import InternAttendanceTimelogsList from "../Pages/InternManagement/InternAttendanceTimelogs/InternAttendanceTimelogsList";
import InterAttendanceRecordList from "../Pages/InternManagement/InternAttendanceRecord/InterAttendanceRecordList";
import IntershipStatusList from "../Pages/InternManagement/Status/IntershipStatusList";
import InternCertificateList from "../Pages/InternManagement/InternCertificate/InternCertificateList";
import InternCertificateForm from "../Pages/InternManagement/InternCertificate/InternCertificateForm";
import FunctionalRoleForm from "../Pages/FunctionalRoles/OrganizationFunctionRoles/FunctionalRoleForm";
import FunctionRolesList from "../Pages/FunctionalRoles/OrganizationFunctionRoles/FunctionRolesList";
import FunctionRoleSpecializationList from "../Pages/FunctionalRoles/FunctionRoleSpecialization/FunctionRoleSpecializationList";
import FunctionRoleSpecializationForm from "../Pages/FunctionalRoles/FunctionRoleSpecialization/FunctionRoleSpecializationForm";
import EmployeeRoleList from "../Pages/FunctionalRoles/EmployeeRoles/EmployeeRoleList";
import EmployeeRoleForm from "../Pages/FunctionalRoles/EmployeeRoles/EmployeeRoleForm";
import CommonList from "../Pages/OptmisedCode/List/CommonList";
import CommonForm from "../Pages/OptmisedCode/Form/CommonForm";
import InternStaagesList from "../Pages/InternManagement/InternStages/InternStaagesList";
import InternStagesForm from "../Pages/InternManagement/InternStages/InternStagesForm";
import EmploymentStagesList from "../Pages/EmployeeManagement/EmploymentStages/EmploymentStagesList";
import EmploymentStagesForm from "../Pages/EmployeeManagement/EmploymentStages/EmploymentStagesForm";
import EmploymentCategoryList from "../Pages/OrganizationConfigration/EmploymentCategory/EmploymentCategoryList";
import EmploymentCategoryForm from "../Pages/OrganizationConfigration/EmploymentCategory/EmploymentCategoryForm";
import OrganizationLevelList from "../Pages/OrganizationConfigration/OrganizationLevel/OrganizationLevelList";
import OrganizationLevelForm from "../Pages/OrganizationConfigration/OrganizationLevel/OrganizationLevelForm";
import OrganizationHierarchy from "../Pages/OrganizationConfigration/OrganizationHierarchy/OrganizationHierarchy";
import SettingActual from "../Pages/SystemModules/Settings/SettingActual";
import EmployeeTransferForm from "../Pages/ToolsAndUtility/EmployeeTransferForm";
import InternRoleList from "../Pages/FunctionalRoles/InternRoles/InternRoleList";
import InternRoleForm from "../Pages/FunctionalRoles/InternRoles/InternRoleForm";
import OrganizationEntityList from "../Pages/Orgnaization/OrganizationEntity/OrganizationEntityList";
import OrganizationEntityForm from "../Pages/Orgnaization/OrganizationEntity/OrganizationEntityForm";
import WorkShiftDayList from "../Pages/Time & Attendence/WorkShiftDays/WorkShiftDayList";
import WorkShiftDayForm from "../Pages/Time & Attendence/WorkShiftDays/WorkShiftDayForm";
import WorkModelDayList from "../Pages/Time & Attendence/WorkModelDays/WorkModelDayList";
import WorkModelDayForm from "../Pages/Time & Attendence/WorkModelDays/WorkModelDayForm";
import SkillCategoryList from "../Pages/Skills/SkillCategory/SkillCategoryList";
import SkillCategoryForm from "../Pages/Skills/SkillCategory/SkillCategoryForm";
import SkillSubCategoryForm from "../Pages/Skills/SkillSubCategory/SkillSubCategoryForm";
import SkillForm from "../Pages/Skills/Skills/SkillForm";
import SkillGroupList from "../Pages/Skills/SkillGroup/SkillGroupList";
import SkillGroupForm from "../Pages/Skills/SkillGroup/SkillGroupForm";
import SkillElementForm from "../Pages/Skills/SkillElement/SkillElementForm";
import FunctionalRoleSkillList from "../Pages/Skills/FunctionalRoleSkill/FunctionalRoleSkillList";
import FunctionalRoleSkillForm from "../Pages/Skills/FunctionalRoleSkill/FunctionalRoleSkillForm";
import RoleSkillElementList from "../Pages/Skills/RoleSkillElement/RoleSkillElementList";
import RoleSkillElementForm from "../Pages/Skills/RoleSkillElement/RoleSkillElementForm";
import PersonalizeDataGrid from "../Components/Table/PersonalizeDataGrid";
import { MAIN_URL } from "../Configurations/Urls";
import useAuthStore from "../Zustand/Store/useAuthStore";
import NotAuthorized from "../Exceptions/NotAuthorized";
import LearningProviderTypeList from "../Pages/Learning/LearningProviderTypes/LearningProviderTypeList";
import LearningProviderTypeForm from "../Pages/Learning/LearningProviderTypes/LearningProviderTypeForm";
import LearningProviderList from "../Pages/Learning/LearningProviders/LearningProviderList";
import LearningProviderForm from "../Pages/Learning/LearningProviders/LearningProviderForm";
import LearningResourcesList from "../Pages/Learning/LearningResources/LearningResourcesList";
import LearningResourcesForm from "../Pages/Learning/LearningResources/LearningResourcesForm";
import LearningFunctionalRoleList from "../Pages/Learning/LearningFunctionalRole/LearningFunctionalRoleList";
import LearningFunctionalRoleForm from "../Pages/Learning/LearningFunctionalRole/LearningFunctionalRoleForm";
import ResourceSkillElementList from "../Pages/Learning/LearningResourceSkillElement/ResourceSkillElementList";
import ResourceSkillElementForm from "../Pages/Learning/LearningResourceSkillElement/ResourceSkillElementForm";
import ActivityLogList from "../Pages/User Management/ActivityLogs/ActivityLogList";
import UserPermissionList from "../Pages/User Management/UserPermission/UserPermissionList";
import UserPermissionForm from "../Pages/User Management/UserPermission/UserPermissionForm";
import ViewUserPermissionForm from "../Pages/User Management/UserPermission/ViewUserPermissionForm";
import LeaveCategoryMonthlySummaryReportList from "../Pages/LeaveManagement/LeaveCategoryMonthlySummaryReport/LeaveCategoryMonthlySummaryReportList";
import LeaveTypeMonthlySummaryReportList from "../Pages/LeaveManagement/LeaveTypeMonthlySummaryReport/LeaveTypeMonthlySummaryReportList";
import InternLeaveMonthlySummaryReportList from "../Pages/InternManagement/InternLeaveMonthlySummaryReport/InternLeaveMonthlySummaryReportList";
import InternLeaveTypeSummaryReportList from "../Pages/InternManagement/InternLeaveTypeSummaryReport/InternLeaveTypeSummaryReportList";
import InternLeaveCategoryMonthlySummaryList from "../Pages/InternManagement/InternLeaveCategoryMonthlySummaryReport/InternLeaveCategoryMonthlySummaryList";
import InternLeaveBalanceReportList from "../Pages/InternManagement/InternLeaveBalanceReport/InternLeaveBalanceReportList";
import IdentificationTypeList from "../Pages/OrganizationConfigration/IdentificationTypes/IdentificationTypeList";
import IdentificationTypeForm from "../Pages/OrganizationConfigration/IdentificationTypes/IdentificationTypeForm";

// Routes
const router = (org)=>createBrowserRouter([
  {
    path: "/",
    element: (
      <RouteProtector>
        <Dashboard />
      </RouteProtector>
    ),
  },

  {
    path: "/attendance/monthly-report",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <AttendanceMonthlyReportList />,
      },
      {
        path: "employees",
        element: <EmployeeMonthlyAttendanceReportList />,
      },
    ],
  },

  // {
  //   path: "/organization/employee/employee-details",
  //   element: <CustomisetableReport />,
  // },
  {
    path: "dashboard/Personalize-dashboard",
    element: (
      <RouteProtector>
        <PersonalizationModal />
      </RouteProtector>
    ),
  },
  {
    path: "/EmployeesForm",
    element: <EmployeesForm />,
  },

  {
    path: "/email-register",
    element: <FreeTrialPage />,
  },

  {
    path: "/otp-verify",
    element: <OtpVerify />,
  },

  {
    path: "/organization-details",
    element: <OrganizationDetails />,
  },

  {
    path: "/users",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <Users />,
      },
      {
        path: "add",
        element: <UsersAdd />,
      },
      {
        path: "edit/:id",
        element: <UsersEdit mode="edit" />,
      },
      {
        path: "view/:id",
        element: <UsersEdit mode="view" />,
      },

      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="Users"
            displayName="Users"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/user?mode=1`}
            contextId="users"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/employee/increment-types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <SalaryIncrementTypesList />,
      },
      {
        path: "add",
        element: <SalaryIncrementTypesForm />,
      },
      {
        path: "edit/:id",
        element: <SalaryIncrementTypesForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <SalaryIncrementTypesForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_employee_increment_types"
            displayName="Increment Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/increment-type?mode=2`}
            contextId="salary-increment-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/work-shift-days",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <WorkShiftDayList />,
      },
      {
        path: "add",
        element: <WorkShiftDayForm />,
      },
      {
        path: "edit/:id",
        element: <WorkShiftDayForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <WorkShiftDayForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_work_shift_days"
            displayName="Workshift Days"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-days?mode=2`}
            contextId="work-shift-days"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/work-model-days",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <WorkModelDayList />,
      },
      {
        path: "add",
        element: <WorkModelDayForm />,
      },
      {
        path: "edit/:id",
        element: <WorkModelDayForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <WorkModelDayForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_work_model_days"
            displayName="Work Model Days"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/workmodel-days?mode=2`}
            contextId="work-model-days"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/intern/internship/types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <IntershipTypesList />,
      },
      {
        path: "add",
        element: <IntershipTypesForm />,
      },
      {
        path: "edit/:id",
        element: <IntershipTypesForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <IntershipTypesForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_internship_types"
            displayName="Intership Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/internship-type?mode=2`}
            contextId="internship-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/intern/certificates",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <InternCertificateList />,
      },
      {
        path: "add",
        element: <InternCertificateForm />,
      },
      {
        path: "edit/:id",
        element: <InternCertificateForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <InternCertificateForm mode="view" />,
      },

      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="intern_certificates"
            displayName="Intern Certificate"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/intern-certificate?mode=2`}
            contextId="intern-certificates"
            filterModule="intern_certificates"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/functional-roles",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <FunctionRolesList />,
      },
      {
        path: "add",
        element: <FunctionalRoleForm />,
      },
      {
        path: "edit/:id",
        element: <FunctionalRoleForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <FunctionalRoleForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_functional_roles"
            displayName="Functional Roles"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/func-role?mode=2`}
            contextId="functional-roles"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/functional-role-specialization",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <FunctionRoleSpecializationList />,
      },
      {
        path: "add",
        element: <FunctionRoleSpecializationForm />,
      },
      {
        path: "edit/:id",
        element: <FunctionRoleSpecializationForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <FunctionRoleSpecializationForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_functional_role_specializations"
            displayName="Functional Role Specialization"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/func-role-spec?mode=2`}
            contextId="functional-role-specialization"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/employee/functional-role",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <EmployeeRoleList />,
      },
      {
        path: "add",
        element: <EmployeeRoleForm />,
      },
      {
        path: "edit/:id",
        element: <EmployeeRoleForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <EmployeeRoleForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="employee_functional_roles"
            displayName="Employee Functional Roles"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/emp-func-role?mode=2`}
            contextId="employee-functional-roles"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/intern/internship/status",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <IntershipStatusList />,
      },
      {
        path: "add",
        element: <IntershipStatusForm />,
      },
      {
        path: "edit/:id",
        element: <IntershipStatusForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <IntershipStatusForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_internship_statuses"
            displayName="Intership Status"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/internship-status?mode=2`}
            contextId="internship-status"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },



  
  {
    path: "/organization-configration/person-identification-type",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <IdentificationTypeList />,
      },
      {
        path: "add",
        element: <IdentificationTypeForm />,
      },
      {
        path: "edit/:id",
        element: <IdentificationTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <IdentificationTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_person_identification_types"
            displayName="Identification Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/person-identification-type?mode=2`}
            contextId="person-identification-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },



  ...Configurations?.map((item) => {
    return {
      path: item.route,
      element: (
        <RouteProtector>
          <CoverLayout />
        </RouteProtector>
      ),
      children: [
        {
          index: true,
          element: <CommonList {...item.ListProps} />,
        },
        {
          path: "add",
          element: <CommonForm {...item.FormProps} />,
        },
        {
          path: "edit/:id",
          element: <CommonForm {...item.FormProps} />,
        },
      ],
    };
  }),

  {
    path: "/intern/document/types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <InternDocumentTypeList />,
      },
      {
        path: "add",
        element: <InternDocumentTypeForm />,
      },
      {
        path: "edit/:id",
        element: <InternDocumentTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <InternDocumentTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="intern_document_types"
            displayName="Intern Document Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/intern-document-types?mode=2`}
            contextId="intern-document-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/intern/intern-stipend",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <InternStipendList />,
      },
      {
        path: "add",
        element: <InternStipendForm />,
      },
      {
        path: "edit/:id",
        element: <InternStipendForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <InternStipendForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="intern_stipends"
            displayName="Intern Stipend"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/intern-stipend?mode=2`}
            contextId="internship-stipends"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/intern/attendance/time-logs",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <InternAttendanceTimelogsList />,
      },
      {
        path: "add",
        element: <InternAttendanceTimelogsForm />,
      },
      {
        path: "edit/:id",
        element: <InternAttendanceTimelogsForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <InternAttendanceTimelogsForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="intern_attendance_timelogs"
            displayName="Intern Attendance Time Logs"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/intern-time-logs?mode=2`}
            contextId="intern-time-logs"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/intern/attendance/records",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <InterAttendanceRecordList />,
      },

      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="intern_attendance_records"
            displayName="Intern Attendance Records"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/intern-attendance-record?mode=2`}
            contextId="intern-attendance-records"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/intern/attendance/monthly-report",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <InternMonthlyAttendanceReportList />,
      },
    ],
  },

  {
    path: "/employee/increment",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <IncrementList />,
      },
      {
        path: "add",
        element: <IncrementForm />,
      },
      {
        path: "edit/:id",
        element: <IncrementForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <IncrementForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="employee_increments"
            displayName="Increments"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/increment?mode=2`}
            contextId="employee-increments"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/employee/records",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <EmployeeRecordList />,
      },
      {
        path: "add",
        element: <EmployeeRecordForm />,
      },
      {
        path: "edit/:id",
        element: <EmployeeRecordForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <EmployeeRecordForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="employee_employment_records"
            displayName="Employee Record"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employee-records?mode=2`}
            contextId="employee-records"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/payroll/component-types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ComponentTypesList />,
      },
      {
        path: "add",
        element: <ComponentTypesForm />,
      },
      {
        path: "edit/:id",
        element: <ComponentTypesForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ComponentTypesForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_component_types"
            displayName="Payroll Component Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-component-type?mode=2`}
            contextId="payroll-component-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/payroll/components",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ComponentList />,
      },
      {
        path: "add",
        element: <ComponentForm />,
      },
      {
        path: "edit/:id",
        element: <ComponentForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ComponentForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_components"
            displayName="Payroll Components"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-component?mode=2`}
            contextId="payroll-components"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/payroll/component-slabs",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollSlabsList />,
      },
      {
        path: "add",
        element: <PayrollSlabsForm />,
      },
      {
        path: "edit/:id",
        element: <PayrollSlabsForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <PayrollSlabsForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_component_slabs"
            displayName="Payroll Component Slabs"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-component-slab?mode=2`}
            contextId="payroll-component-slabs"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/payroll/cycles",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollCycleList />,
      },
      {
        path: "add",
        element: <PayrollCycleForm />,
      },
      {
        path: "edit/:id",
        element: <PayrollCycleForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <PayrollCycleForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_cycles"
            displayName="Payroll Cycle"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-cycle?mode=2`}
            contextId="payroll-cycles"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/payroll/employee-salary-structure",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <SalaryStructureList />,
      },
      {
        path: "add",
        element: <SalaryStructureForm />,
      },
      {
        path: "edit/:id",
        element: <SalaryStructureForm mode="edit" />,
      },
        {
        path: "view/:id",
        element: <SalaryStructureForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_employee_salary_structures"
            displayName="Employee Salary Structure"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employee-salary-structure?mode=2`}
            contextId="employee-salary-structures"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/payroll/salary-structure/components",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <SalaryStructureComponentList />,
      },
      {
        path: "add",
        element: <SalaryStructureComponentForm />,
      },
      {
        path: "edit/:id",
        element: <SalaryStructureComponentForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <SalaryStructureComponentForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_employee_salary_structure_components"
            displayName="Salary Structure Component"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll/salary-component?mode=2`}
            contextId="payroll-salary-structure-components"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/payroll/advance",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <AdvancePayrollList />,
      },
      {
        path: "add",
        element: <AdvancePayrollForm />,
      },
      {
        path: "edit/:id",
        element: <AdvancePayrollForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <AdvancePayrollForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_advances"
            displayName="Advance Payrolls"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-advance?mode=2`}
            contextId="payroll-advances"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/payroll/loan-types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollLoanTypesList />,
      },
      {
        path: "add",
        element: <PayrollLoanTypesForm />,
      },
      {
        path: "edit/:id",
        element: <PayrollLoanTypesForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <PayrollLoanTypesForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_loan_types"
            displayName="Payroll Loan Type"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-loan-type?mode=2`}
            contextId="payroll-loan-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/payroll/loans",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollLoanList />,
      },
      {
        path: "add",
        element: <PayrollLoanForm />,
      },
      {
        path: "edit/:id",
        element: <PayrollLoanForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <PayrollLoanForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_loans"
            displayName="Payroll Loans"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-loan?mode=2`}
            contextId="payroll-loans"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/payroll/loan-transactions",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollLoanTransactionList />,
      },
      {
        path: "add",
        element: <PayrollLoanTransactionForm />,
      },
      {
        path: "edit/:id",
        element: <PayrollLoanTransactionForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <PayrollLoanTransactionForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_loan_transactions"
            displayName="Payroll Loan Transactions"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-loan-transaction?mode=2`}
            contextId="payroll-loan-transactions"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/payroll/securities",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollSecurityList />,
      },
      {
        path: "add",
        element: <PayrollSecurityForm />,
      },
      {
        path: "edit/:id",
        element: <PayrollSecurityForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <PayrollSecurityForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_securities"
            displayName="Payroll Security"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-security?mode=2`}
            contextId="payroll-securities"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/payroll/securities-transactions",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollSecurityTransactionList />,
      },
      {
        path: "add",
        element: <PayrollSecurityTransactionForm />,
      },
      {
        path: "edit/:id",
        element: <PayrollSecurityTransactionForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <PayrollSecurityTransactionForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_security_transactions"
            displayName="Payroll Security Transactions"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-security-transaction?mode=2`}
            contextId="payroll-security-transactions"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/attendance/employee-record-without-break",
    element: (
      <RouteProtector>
        <RecordWithoutBreakList />
      </RouteProtector>
    ),
  },

  {
    path: "/my-profile",
    element: (
      <RouteProtector>
        <MyProfile />
      </RouteProtector>
    ),
  },

  {
    path: "/organization/details",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationAddInList />,
      },
      {
        path: "add",
        element: <OrganizationAddInForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationAddInForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <OrganizationAddInForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_loan_types"
            displayName="Payroll Loan Type"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-loan-type?mode=2`}
            contextId="payroll-loan-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/system/dynamic-forms",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <DynamicFormPage />,
      },
    ],
  },

  {
    path: "/organization/employee-shift",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <EmployeeTransferForm />,
      },
    ],
  },

  {
    path: "/organization/settings/new",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <SettingActual />,
      },
    ],
  },
  {
    path: "/organization/application-access",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationApplicationAccess />,
      },
    ],
  },

  {
    path: "/organization/work-shift-assignment",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <WorkshiftAssignmentList />,
      },
      {
        path: "add",
        element: <WorkshiftAssignmentForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <WorkshiftAssignmentForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <WorkshiftAssignmentForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="employee_work_shift_assignments"
            displayName="Employee WorkShift Assignments"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-assignment?mode=1`}
            contextId="work-shift-assignments"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/work-shift-rotation-pattern",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <WorkShiftRotationPatternList />,
      },
      {
        path: "add",
        element: <WorkShiftRotationPatternForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <WorkShiftRotationPatternForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <WorkShiftRotationPatternForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_work_shift_rotation_patterns"
            displayName="WorkShift Rotation Patterns"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-rotation-pattern?mode=1`}
            contextId="work-shift-rotation-patterns"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/work-shift-rotation-days",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <WorkShiftRotationDayList />,
      },
      {
        path: "add",
        element: <WorkShiftRotationDayForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <WorkShiftRotationDayForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <WorkShiftRotationDayForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_work_shift_rotation_days"
            displayName="WorkShift Rotation Days"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-rotation-days?mode=2`}
            contextId="work-shift-rotation-days"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/work-shift-rotation-assignment",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <WorkShiftRotationAssignmentList />,
      },
      {
        path: "add",
        element: <WorkShiftRotationAssignmentForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <WorkShiftRotationAssignmentForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <WorkShiftRotationAssignmentForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="employee_work_shift_rotation_assignments"
            displayName="WorkShift Rotation Assignments"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-rotation-assignment?mode=2`}
            contextId="work-shift-rotation-assignments"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
        
      },
    ],
  },

  {
    path: "/my-tasks",
    element: (
      <RouteProtector>
        <MyTasks />
      </RouteProtector>
    ),
  },
  {
    path: "/settings/change-password",
    element: (
      <RouteProtector>
        <ChangePassword />
      </RouteProtector>
    ),
  },
  {
    path: "/settings/update-credentials",
    element: (
      <RouteProtector>
        <UpdateCredentials />
      </RouteProtector>
    ),
  },
  {
    path: "/organization/data",
    element: (
      <RouteProtector>
        <Organisation />
      </RouteProtector>
    ),
  },
  {
    path: "/organization/profile",
    element: (
      <RouteProtector>
        <OrganizationProfile />
      </RouteProtector>
    ),
  },
  {
    path: "/organization/attendance-kiosk",
    element: (
      <RouteProtector>
        <FaceAuth />
      </RouteProtector>
    ),
  },

  {
    path: "/organization/workshift-break",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <WorkshiftBreakList />,
      },
      {
        path: "add",
        element: <WorkshiftBreakForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <WorkshiftBreakForm mode="edit" />,
      },
        {
        path: "view/:id",
        element: <WorkshiftBreakForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_work_shift_breaks"
            displayName="Workshift Break"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-breaks?mode=2`}
            contextId="work-shift-breaks"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/attendance-break",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <AttendanceBreakList />,
      },
      {
        path: "add",
        element: <AttendanceBreakForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <AttendanceBreakForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <AttendanceBreakForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_attendance_breaks"
            displayName="Attendance Break"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-breaks?mode=2`}
            contextId="attendance-breaks"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/departments",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationDepartmentsList />,
      },
      {
        path: "add",
        element: <OrganizationDepartmentForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationDepartmentForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <OrganizationDepartmentForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="departments"
            displayName="Departments"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/department?mode=2`}
            contextId="departments"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },



  {
    path: "/organization/learning-provider-type",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LearningProviderTypeList />,
      },
      {
        path: "add",
        element: <LearningProviderTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <LearningProviderTypeForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <LearningProviderTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_learning_provider_types"
            displayName="Learning Provider Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/learning-provider-type?mode=2`}
            contextId="learning-provider-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/units",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationUnitList />,
      },
      {
        path: "add",
        element: <OrganizationUnitForms mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationUnitForms mode="edit" />,
      },
      {
        path: "view/:id",
        element: <OrganizationUnitForms mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_units"
            displayName="Organization Units"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/units?mode=2`}
            contextId="units"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/learning-provider",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LearningProviderList />,
      },
      {
        path: "add",
        element: <LearningProviderForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <LearningProviderForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <LearningProviderForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_learning_providers"
            displayName="Learning Provider"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/learning-provider?mode=2`}
            contextId="learning-providers"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/learning-resources",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LearningResourcesList />,
      },
      {
        path: "add",
        element: <LearningResourcesForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <LearningResourcesForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <LearningResourcesForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_learning_resources"
            displayName="Learning Resources"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/learning-resources?mode=2`}
            contextId="learning-resources"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/learning-functional-role",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LearningFunctionalRoleList />,
      },
      {
        path: "add",
        element: <LearningFunctionalRoleForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <LearningFunctionalRoleForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <LearningFunctionalRoleForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_learning_resource_functional_roles"
            displayName="Learning Functional Role"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/learning-func-role?mode=2`}
            contextId="learning-functional-roles"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/learning-skill-element",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ResourceSkillElementList />,
      },
      {
        path: "add",
        element: <ResourceSkillElementForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ResourceSkillElementForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ResourceSkillElementForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_learning_resource_skill_elements"
            displayName="Learning Resource Skill Element"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/learning-skill-element?mode=2`}
            contextId="resource-skill-elements"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/payroll/runs",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollRunList />,
      },
      {
        path: "add",
        element: <PayrollRunForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <PayrollRunForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <PayrollRunForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_runs"
            displayName="Payroll Runs"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-run?mode=2`}
            contextId="payroll-runs"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/skill-category",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <SkillCategoryList />,
      },
      {
        path: "add",
        element: <SkillCategoryForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <SkillCategoryForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <SkillCategoryForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_skill_categories"
            displayName="Organization Skill Categories"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/skill-category?mode=2`}
            contextId="skill-categories"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/skill-subcategory",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        path: "add",
        element: <SkillSubCategoryForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <SkillSubCategoryForm mode="edit" />,
      },
        {
        path: "view/:id",
        element: <SkillSubCategoryForm mode="view" />,
      },

      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_skill_subcategories"
            displayName="Organization Skill Subcategories"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/skill-subcategory?mode=2`}
            contextId="skill-subcategories"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/skills",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      
      {
        path: "add",
        element: <SkillForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <SkillForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <SkillForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_skills"
            displayName="Organization Skills"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/skill?mode=2`}
            contextId="skills"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/skill-element-group",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <SkillGroupList />,
      },
      {
        path: "add",
        element: <SkillGroupForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <SkillGroupForm mode="edit" />,
      },
        {
        path: "view/:id",
        element: <SkillGroupForm mode="view" />,
      },
    ],
  },

  {
    path: "/organization/skill-element",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      
      {
        path: "add",
        element: <SkillElementForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <SkillElementForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <SkillElementForm mode="view" />,
      },

      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_skill_elements"
            displayName="Organization Skill Elements"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/skill-element?mode=2`}
            contextId="skill-elements"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/func-role-skill",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <FunctionalRoleSkillList />,
      },
      
      {
        path: "add",
        element: <FunctionalRoleSkillForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <FunctionalRoleSkillForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <FunctionalRoleSkillForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_functional_role_skills"
            displayName="Role Skills"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/func-role-skill?mode=2`}
            contextId="func-role-skills"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/func-role-skill-element",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <RoleSkillElementList />,
      },
      
      {
        path: "add",
        element: <RoleSkillElementForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <RoleSkillElementForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <RoleSkillElementForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_functional_role_skill_elements"
            displayName="Functional Role Skill Elements"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/func-role-skill-element?mode=2`}
            contextId="role-skill-elements"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/payroll/employee-runs",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollRunEmployeeList />,
      },
      {
        path: "add",
        element: <PayrollRunEmployeeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <PayrollRunEmployeeForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <PayrollRunEmployeeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="payroll_run_employees"
            displayName="Payroll Run Employees"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-employee-runs?mode=2`}
            contextId="payroll-run-employees"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/payroll/employee-run/components",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollRunEmployeeComponentList />,
      },
      {
        path: "add",
        element: <PayrollRunEmployeeComponentForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <PayrollRunEmployeeComponentForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <PayrollRunEmployeeComponentForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="payroll_run_employee_components"
            displayName="Payroll Run Employee Components"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-run-employee-component?mode=2`}
            contextId="payroll-run-employee-components"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/payroll/periods",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollPeriodList />,
      },
      {
        path: "add",
        element: <PayrollPeriodForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <PayrollPeriodForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <PayrollPeriodForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_periods"
            displayName="Payroll Periods"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-period?mode=2`}
            contextId="payroll-periods"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/payslips/payments",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayslipPaymentList />,
      },
      {
        path: "add",
        element: <PayslipPaymentForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <PayslipPaymentForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <PayslipPaymentForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="employee_payslip_payments"
            displayName="Employee Payslip Payments"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employee-payslip-payment?mode=2`}
            contextId="employee-payslip-payments"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/payslips/components",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <EmployeePayslipComponentList />,
      },
      {
        path: "add",
        element: <EmployeePayslipComponentForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <EmployeePayslipComponentForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <EmployeePayslipComponentForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="employee_payslip_components"
            displayName="Employee Payslip Components"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employee-payslip-component?mode=2`}
            contextId="employee-payslip-components"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/payroll/reimbursement-types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollReimbursementTypeList />,
      },
      {
        path: "add",
        element: <PayrollReimbursementTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <PayrollReimbursementTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <PayrollReimbursementTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_reimbursement_types"
            displayName="Payroll Reimbursement Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-reimbursement-type?mode=2`}
            contextId="payroll-reimbursement-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/employee-leave-type-monthly-summary",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LeaveTypeMonthlySummaryReportList />,
      },

      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_person_leave_type_monthly_summaries"
            displayName="Leave Type Monthly Summary Report"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employee-leave-type-monthly-summary?mode=2`}
            contextId="organization_person_leave_type_monthly_summaries"
            filterModule="organization_person_leave_type_monthly_summaries"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },


      
      
    ],
  },
  {
    path: "/employee-leave-category-monthly-summary",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LeaveCategoryMonthlySummaryReportList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_person_leave_category_monthly_summaries"
            displayName="Leave Category Monthly Summary Report"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employee-leave-category-monthly-summary?mode=2`}
            contextId="organization_person_leave_category_monthly_summaries"
            filterModule="organization_person_leave_category_monthly_summaries"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },


  {
    path: "/intern/leave-monthly-summary",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,  
        element: <InternLeaveMonthlySummaryReportList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="intern_leave_monthly_summaries"
            displayName="Intern Leave Monthly Summary Report"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leave-summaries?mode=1`}
            contextId="intern-leave-monthly-summary"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },


    ],
  },

  {
    path: "/intern/leave-type-monthly-summary",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,  
        element: <InternLeaveTypeSummaryReportList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="intern_leave_type_monthly_summaries"
            displayName="Intern Leave Type Monthly Summary Report"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leave-type-monthly-summary?mode=1`}
            contextId="intern-leave-type-monthly-summary"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
 
  {
    path: "/intern/leave-category-monthly-summary",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,  
        element: <InternLeaveCategoryMonthlySummaryList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="intern_leave_category_monthly_summaries"
            displayName="Intern Leave Category Monthly Summary Report"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leave-category-monthly-summary?mode=1`}
            contextId="intern-leave-category-monthly-summary"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/intern/leave-balance-report",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,  
        element: <InternLeaveBalanceReportList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="intern_leave_balances"
            displayName="Intern Leave Balance Report"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leave-balances?mode=1`}
            contextId="intern-leave-balances"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
 
  {
    path: "/payroll/reimbursements",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollReimbursementList />,
      },
      {
        path: "add",
        element: <PayrollReimbursementForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <PayrollReimbursementForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <PayrollReimbursementForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_reimbursements"
            displayName="Payroll Reimbursements"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-reimbursement?mode=2`}
            contextId="payroll-reimbursements"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/payroll/adjustment-types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollAdjustmentTypeList />,
      },
      {
        path: "add",
        element: <PayrollAdjustmentTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <PayrollAdjustmentTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <PayrollAdjustmentTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_adjustment_types"
            displayName="Payroll Adjustment Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-adjustment-type?mode=2`}
            contextId="payroll-adjustment-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/payroll/adjustments",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollAdjustmentList />,
      },
      {
        path: "add",
        element: <PayrollAdjustmentForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <PayrollAdjustmentForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <PayrollAdjustmentForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_adjustments"
            displayName="Payroll Adjustments"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-adjustment?mode=2`}
            contextId="payroll-adjustments"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/designation",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationDesignationsList />,
      },
      {
        path: "add",
        element: <OrganizationDesignationsForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationDesignationsForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <OrganizationDesignationsForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_designations"
            displayName="Designations"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/designation?mode=1`}
            contextId="designations"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },


    ],
  },
  {
    path: "/recruitment/source-types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <RecruitmentSourceTypesList /> },
      { path: "add", element: <RecruitmentSourceTypesForm mode="add" /> },
      { path: "edit/:id", element: <RecruitmentSourceTypesForm mode="edit" /> },
      { path: "view/:id", element: <RecruitmentSourceTypesForm mode="view" /> },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_recruitment_source_types"
            displayName="Recruitment Source Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/recruitment-source-type?mode=1`}
            contextId="recruitment-source-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/recruitment/sources",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <RecruitmentSourcesList /> },
      { path: "add", element: <RecruitmentSourcesForm mode="add" /> },
      { path: "edit/:id", element: <RecruitmentSourcesForm mode="edit" /> },
      { path: "view/:id", element: <RecruitmentSourcesForm mode="view" /> },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_recruitment_sources"
            displayName="Recruitment Sources"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/recruitment-source?mode=1`}
            contextId="recruitment-sources"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/recruitment/source-contacts",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <RecruitmentSourceContactsList /> },
      { path: "add", element: <RecruitmentSourceContactsForm mode="add" /> },
      { path: "edit/:id", element: <RecruitmentSourceContactsForm mode="edit" /> },
      { path: "view/:id", element: <RecruitmentSourceContactsForm mode="view" /> },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_recruitment_source_contacts"
            displayName="Recruitment Source Contacts"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/recruitment-source-contact?mode=1`}
            contextId="recruitment-source-contacts"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/recruitment/openings",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <RecruitmentOpeningsList /> },
      { path: "add", element: <RecruitmentOpeningsForm mode="add" /> },
      { path: "edit/:id", element: <RecruitmentOpeningsForm mode="edit" /> },
      { path: "view/:id", element: <RecruitmentOpeningsForm mode="view" /> },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_recruitment_openings"
            displayName="Recruitment Openings"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/recruitment-opening?mode=1`}
            contextId="recruitment-openings"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/recruitment/applications",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <RecruitmentApplicationsList /> },
      { path: "add", element: <RecruitmentApplicationsForm mode="add" /> },
      { path: "edit/:id", element: <RecruitmentApplicationsForm mode="edit" /> },
      { path: "view/:id", element: <RecruitmentApplicationsForm mode="view" /> },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_recruitment_applications"
            displayName="Recruitment Applications"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/recruitment-application?mode=1`}
            contextId="recruitment-applications"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/registrations",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationRegistrationsList />,
      },
      {
        path: "add",
        element: <OrganizationRegistrationsForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationRegistrationsForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <OrganizationRegistrationsForm mode="view" />,
      },

      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_business_registrations"
            displayName="Registrations"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/business-registration?mode=2`}
            contextId="organization_business_registrations"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },



    ],
  },

  {
    path: "/organization-configration/business-ownership-type",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <BusinessOwnershipTypeList />,
      },
      {
        path: "add",
        element: <BusinessOwnershipTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <BusinessOwnershipTypeForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <BusinessOwnershipTypeForm mode="view" />,
      },

      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_business_ownership_types"
            displayName="Business Ownership Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/business-ownership-type?mode=2`}
            contextId="business-ownership-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/payroll/journal-entries",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollJourneyEntriesList />,
      },
      {
        path: "add",
        element: <PayrollJourneyEntriesForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <PayrollJourneyEntriesForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <PayrollJourneyEntriesForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_journal_entries"
            displayName="Payroll Journal Entries"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-journal-entries?mode=2`}
            contextId="payroll-journal-entries"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/payroll/account-mapping",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <PayrollAccountMappingList />,
      },
      {
        path: "add",
        element: <PayrollAccountMappingForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <PayrollAccountMappingForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <PayrollAccountMappingForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_payroll_account_mappings"
            displayName="Organization Payroll Account Mappings"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/payroll-account-mapping?mode=2`}
            contextId="payroll-account-mappings"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization-configration/business-registration-type",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <BusinessRegistrationTypeList />,
      },
      {
        path: "add",
        element: <BusinessRegistrationTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <BusinessRegistrationTypeForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <BusinessRegistrationTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_business_registration_types"
            displayName="Business registration Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/business-registration-type?mode=2`}
            contextId="business-registration-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization-configration/unit-types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <BusinessUnitTypeList />,
      },
      {
        path: "add",
        element: <BusinessUnitTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <BusinessUnitTypeForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <BusinessUnitTypeForm mode="view" />,
      },

      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_units_types"
            displayName="Organization Units Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/units-types?mode=2`}
            contextId="units-types"
            mode="personalize-view"
            orgId={org?.organization_id}  
          />
        ),
      },
    ],
  },
  {
    path: "/organization-configration/languages",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationLanguageList />,
      },
      {
        path: "add",
        element: <OrganizationLanguageForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationLanguageForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <OrganizationLanguageForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_languages"
            displayName="Languages"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/language?mode=2`}
            contextId="languages"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/intern/intern-stages",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <InternStaagesList />,
      },
      {
        path: "add",
        element: <InternStagesForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <InternStagesForm mode="edit" />,
      },
        {
        path: "view/:id",
        element: <InternStagesForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_internship_stages"
            displayName="Internship Stages"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/internship-stages?mode=1`}
            contextId="intern-stages"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/employment/employee-stages",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <EmploymentStagesList />,
      },
      {
        path: "add",
        element: <EmploymentStagesForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <EmploymentStagesForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <EmploymentStagesForm mode="view" />,
      },

      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_employment_stages"
            displayName="Employment Stages"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employment-stages?mode=2`}
            contextId="employment-stages"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization-configration/residential-ownership-type",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ResidentialOwnershipTypeList />,
      },
      {
        path: "add",
        element: <ResidentialOwnershipTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ResidentialOwnershipTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ResidentialOwnershipTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_residential_ownership_types"
            displayName="Residential OwnershipType"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/residential-ownership-type?mode=2`}
            contextId="residential-ownership-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization-configration/location-ownership-type",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LocationOwnershipTypeList />,
      },
      {
        path: "add",
        element: <LocationOwnershipTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <LocationOwnershipTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <LocationOwnershipTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_location_ownership_types"
            displayName="Location OwnershipType"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/location-ownership-type?mode=2`}
            contextId="location-ownership-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization-configration/employee-address-types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationEmployeeAddressTypeList />,
      },
      {
        path: "add",
        element: <OrganizationEmployeeAddressTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationEmployeeAddressTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <OrganizationEmployeeAddressTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_employee_address_types"
            displayName="Address Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employemnt-addresstype?mode=2`}
            contextId="employee-address-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization-configration/employee-status",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationEmployementStatusesList />,
      },
      {
        path: "add",
        element: <OrganizationEmployementStatusesForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationEmployementStatusesForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <OrganizationEmployementStatusesForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_employment_statuses"
            displayName="Employment Status"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employment-status?mode=2`}
            contextId="employement-statuses"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },


    ],
  },

  {
    path: "/employee/document/types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <DocumentTypesList />,
      },
      {
        path: "add",
        element: <DocumentTypesForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <DocumentTypesForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <DocumentTypesForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="employee_document_types"
            displayName="Document Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employemnt-document-type?mode=2`}
            contextId="document-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/employee/document/links",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <DocumentLinkList />,
      },
      {
        path: "add",
        element: <DocumentLinkForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <DocumentLinkForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <DocumentLinkForm mode="view" />,
      },
    ],
  },

  {
    path: "/employee/documents",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <Documentist />,
      },
      {
        path: "add",
        element: <DocumentForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <DocumentForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <DocumentForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="employee_documents"
            displayName="Employee Documents"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employemnt-document?mode=2`}
            contextId="employee-documents"
            filterModule="employee_documents"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/employee/employee-details/employee-profile",
    element: (
      <RouteProtector>
        <EmployeeProfile />
      </RouteProtector>
    ),
  },

  {
    path: "/organization-configration/employement-type",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationEmployementTypesList />,
      },
      {
        path: "add",
        element: <OrganizationEmployementTypesForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationEmployementTypesForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <OrganizationEmployementTypesForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_employment_types"
            displayName="Employment Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employemnt-type?mode=2`}
            contextId="employement-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization-configration/employement-exit-reason-type",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationEmployementExitReasonTypeList />,
      },
      {
        path: "add",
        element: <OrganizationEmployementExitReasonTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationEmployementExitReasonTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <OrganizationEmployementExitReasonTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_employment_exit_reason_types"
            displayName="Exit Reason Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employment-exit-reason-type?mode=2`}
            contextId="employment-exit-reason-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/intern/functional-role",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <InternRoleList />,
      },
      {
        path: "add",
        element: <InternRoleForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <InternRoleForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <InternRoleForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="intern_functional_roles"
            displayName="Intern Functional Roles"
            dataApi={org?.organization_id ? `${MAIN_URL}/api/organizations/${org.organization_id}/intern-func-role?mode=1` : null}
            contextId="intern-roles"
            filterModule="intern_functional_roles"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization-configration/employement-exit-reason",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationEmployementExitReasonsList />,
      },
      {
        path: "add",
        element: <OrganizationEmployementExitReasonsForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationEmployementExitReasonsForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <OrganizationEmployementExitReasonsForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_employment_exit_reasons"
            displayName="Exit Reason"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employemnt-exit-reason?mode=2`}
            contextId="employment-exit-reasons"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },


  


  {
    path: "/organization/entity",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationEntityList />,
      },
      {
        path: "add",
        element: <OrganizationEntityForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationEntityForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <OrganizationEntityForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_employment_exit_reasons"
            displayName="Exit Reason"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employemnt-exit-reason?mode=2`}
            contextId="employment-exit-reasons"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_entities"
            displayName="Organization Entities"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/entity?mode=2`}
            contextId="entities"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization-configration/holiday-types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <HolidayTypesList />,
      },
      {
        path: "add",
        element: <HolidayTypesForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <HolidayTypesForm mode="edit" />,
      },
        {
        path: "view/:id",
        element: <HolidayTypesForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_holiday_types"
            displayName="Holiday Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/holiday-type?mode=2`}
            contextId="holiday-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization-configration/leave-category",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LeaveCategoryList />,
      },
      {
        path: "add",
        element: <LeaveCategoryForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <LeaveCategoryForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <LeaveCategoryForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_leave_categories"
            displayName="Leave Categories"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/leave-category?mode=2`}
            contextId="leave-categories"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization-configration/leave-types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LeaveTypeList />,
      },
      {
        path: "add",
        element: <LeaveTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <LeaveTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <LeaveTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_leave_types"
            displayName="Leave Type"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/leave-type?mode=2`}
            contextId="leave-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization-configration/leave-reason",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LeaveReasonList />,
      },
      {
        path: "add",
        element: <LeaveReasonForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <LeaveReasonForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <LeaveReasonForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_leave_reasons"
            displayName="Leave Reasons"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/leave-reason?mode=2`}
            contextId="leave-reasons"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization-configration/leave-reason-type",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LeaveReasonTypeList />,
      },
      {
        path: "add",
        element: <LeaveReasonTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <LeaveReasonTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <LeaveReasonTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_leave_reason_types"
            displayName="Leave Reason Type"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/leave-reason-type?mode=2`}
            contextId="leave-reason-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization-configration/workshift-types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <WorkShiftTypeList />,
      },
      {
        path: "add",
        element: <WorkShiftTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <WorkShiftTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <WorkShiftTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_work_shift_types"
            displayName="Workshift Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/workshift-type?mode=2`}
            contextId="workshift-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization-configration/work-model",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <WorkModelList />,
      },
      {
        path: "add",
        element: <WorkModelForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <WorkModelForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <WorkModelForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_work_models"
            displayName="Work Models"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/work-model?mode=2`}
            contextId="work-models"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/application/user-role-permission",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <RolePermissionList />,
      },
      {
        path: "add",
        element: <RolePermissionForm mode="add" />,
      },
      {
        path: "view/:id",
        element: <ViewRolePermissionForm mode="edit" />,
      },
      {
        path: "edit/:id",
        element: <RolePermissionForm mode="edit" />,
      },
    ],
  },






    {
    path: "/application/activity-logs",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ActivityLogList />,
      },
    ],
  },

  {
    path: "/application/user-permission",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <UserPermissionList />,
      },
      {
        path: "add",
        element: <UserPermissionForm mode="add" />,
      },
      {
        path: "view/:id",
        element: <ViewUserPermissionForm mode="edit" />,
      },
      {
        path: "edit/:id",
        element: <UserPermissionForm mode="edit" />,
      },
    ],
  },






  {
    path: "/application/userrole-assignments",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <RoleAssignmentList />,
      },
      {
        path: "add",
        element: <RoleAssignmentForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <RoleAssignmentForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <RoleAssignmentForm mode="view" />,
      },
    ],
  },

  {
    path: "/organization-configration/user-types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <UserTypeList />,
      },
      {
        path: "add",
        element: <UserTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <UserTypeForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <UserTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_user_types"
            displayName="User Types"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/user-type?mode=2`}
            contextId="user-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/setting-types",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <SettingTypeList />,
      },
      {
        path: "add",
        element: <SettingTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <SettingTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <SettingTypeForm mode="view" />,
      },
    ],
  },

  {
    path: "/organization/settings",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <SettingList />,
      },
      {
        path: "add",
        element: <SettingForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <SettingForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <SettingForm mode="view" />,
      },
    ],
  },

  // {
  //   path: "/organization/employee/employee-details",
  //   element: (
  //     <RouteProtector>
  //       <CoverLayout />
  //     </RouteProtector>
  //   ),
  //   children: [
  //     {
  //       index: true,
  //       element: <EmployeeList />,
  //     },
  //     {
  //       path: "add",
  //       element: <DynamicFormPage mode="add" />,
  //     },
  //     {
  //       path: "edit/:id",
  //       element: <DynamicFormPage mode="edit" />,
  //     },
  //     {
  //       path: "view/:id",
  //       element: <DynamicFormPage mode="view" />,
  //     },
  //   ],
  // },


     {
      path: "/organization/employee/employee-details",
      element: (
        <RouteProtector>
          <CoverLayout />
        </RouteProtector>
      ),
      children: [
        {
          index: true,
          element: <EmployeeList />,
        },
        {
          path: "add",
          element: <DynamicFormPage mode="add" />,
        },
        {
          path: "edit/:id",
          element: <DynamicFormPage mode="edit" />,
        },
        {
          path: "view/:id",
          element: <DynamicFormPage mode="view" />,
        },
        {
          path: "personalize-view",
          element: (
            <PersonalizeDataGrid
              tableName="Employees"
              displayName="Employees"
              dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employee?mode=2`}
              contextId="employees"
              filterModule="employees"
              mode="personalize-view"
              orgId={org?.organization_id}
            />
          ),
        },
      ],
    },
    
  {
    path: "/organization/intern/intern-details",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <InternList />,
      },
      {
        path: "add",
        element: <DynamicFormInternPage mode="add" />,
      },
      {
        path: "edit/:id",
        element: <DynamicFormInternPage mode="edit" />,
      },
      {
        path: "view/:id",
        element: <DynamicFormInternPage mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="Interns"
            displayName="Interns"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/interns?mode=2`}
            contextId="interns"
            filterModule="interns"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/freelancer/freelancer-details",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <EmployeeList />,
      },
      {
        path: "add",
        element: <DynamicFormInternPage mode="add" />,
      },
      {
        path: "edit/:id",
        element: <DynamicFormInternPage mode="edit" />,
      },
    ],
  },

  {
    path: "/organization/intern/intern-exit",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <InterExitRecordList />,
      },
      {
        path: "add",
        element: <InterExitRecordForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <InterExitRecordForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <InterExitRecordForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="intern_exit_records"
            displayName="Intern Exit"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/intern-exit?mode=2`}
            contextId="intern-exit-records"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/intern/intern-leaves",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <InternLeaveList />,
      },
      {
        path: "add",
        element: <InternLeaveForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <InternLeaveForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <InternLeaveForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="intern_leaves"
            displayName="Intern Leaves"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/intern-leaves?mode=2`}
            contextId="intern-leaves"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization-configration/datagrid-config",
    element: (
      <RouteProtector>
        <MultiTableConfig />
      </RouteProtector>
    ),
  },

  {
    path: "/organization/employee/employee-exits",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <EmployeeExitList />,
      },
      {
        path: "add",
        element: <EmployeeExitForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <EmployeeExitForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <EmployeeExitForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="employee_exits"
            displayName="Employee Exit"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employee-exit?mode=2`}
            contextId="employee-exits"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/leave/holiday-calendar",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <HolidayCalendarList />,
      },
      {
        path: "add",
        element: <HolidayCalendarForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <HolidayCalendarForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <HolidayCalendarForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_holiday_calendars"
            displayName="Holiday Calendar"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/holiday-calendar?mode=1`}
            contextId="holiday-calendars"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/leave/employee-entitlements",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <EmployeeLeaveEntitlementList />,
      },
      {
        path: "add",
        element: <EmployeeLeaveEntitlmentForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <EmployeeLeaveEntitlmentForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <EmployeeLeaveEntitlmentForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_leave_entitlements"
            displayName="Employee Leave Entitlement"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employee-leave-entitlement?mode=2`}
            contextId="employee-leave-entitlements"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
          
        ),
      },
    ],
  },

  {
    path: "/attendance/employee-record",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <AttendanceRecordList />,
      },
      {
        path: "add",
        element: <AttendanceRecordForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <AttendanceRecordForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <AttendanceRecordForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_person_attendance_records"
            displayName="Attendance Records"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-employee-record?mode=2`}
            contextId="attendance-records"
            filterModule="employee_attendance_records"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/attendance/time-logs",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <AttendanceTimelogsList />,
      },
      {
        path: "add",
        element: <AttendanceTimelogsForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <AttendanceTimelogsForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <AttendanceTimelogsForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_person_attendance_timelogs"
            displayName="Attendance Time Logs"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-time-logs?mode=2`}
            contextId="attendance-timelogs"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/attendance/deviation-records",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <AttendanceDeviationRecordList />,
      },
      {
        path: "add",
        element: <AttendanceDeviationRecordForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <AttendanceDeviationRecordForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <AttendanceDeviationRecordForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_attendance_deviation_records"
            displayName="Organization Attendance Deviation Records"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-deviation-record?mode=2`}
            contextId="attendance-deviation-records"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/attendance/status-type",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <AttendenceStatusTypeList />,
      },
      {
        path: "add",
        element: <AttendenceStatusTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <AttendenceStatusTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <AttendenceStatusTypeForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_attendance_status_types"
            displayName="Attendance Status Type"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-status-type?mode=2`}
            contextId="attendance-status-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "employee-leave-balance-report",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LevaeBalanceReportList />,
      },

      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="employee_leave_balances"
            displayName="Employee Leave Balance Report"
              dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/leave-balances/taken?mode=2`}
            contextId="employee-leave-balance-report"
            filterModule="employee_leave_balances"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/employee-leave-summary",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LeaveSummaryMonthlyReport />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_person_leave_monthly_summaries"
            displayName="Employee Leave Monthly Summary Report"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employee-monthlyleave-summary?mode=1`}
            contextId="employee-leave-summary"
            filterModule="organization_person_leave_monthly_summaries"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/attendance/source",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <AttendenceSourceList />,
      },
      {
        path: "add",
        element: <AttendenceSourceForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <AttendenceSourceForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <AttendenceSourceForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_attendance_sources"
            displayName="Attendance Sources"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-source?mode=2`}
            contextId="attendance-sources"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/attendance/deviation-reason",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <AttendanceDeviationReasonList />,
      },
      {
        path: "add",
        element: <AttendanceDeviationReasonForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <AttendanceDeviationReasonForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <AttendanceDeviationReasonForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_attendance_deviation_reasons"
            displayName="Attendance Deviation Reason"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-deviation-reason?mode=2`}
            contextId="attendance-deviation-reasons"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization-configration/organization-level",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationLevelList />,
      },
      {
        path: "add",
        element: <OrganizationLevelForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationLevelForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <OrganizationLevelForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_levels"
            displayName="Organization Levels"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/organization-level?mode=2`}
            contextId="organization-levels"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization-configration/organization-hierarchy",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationHierarchy />,
      },
    ],
  },

  {
    path: "/organization-configration/employement-category",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <EmploymentCategoryList />,
      },
      {
        path: "add",
        element: <EmploymentCategoryForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <EmploymentCategoryForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <EmploymentCategoryForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_employment_categories"
            displayName="Employment Category"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/categories?mode=2`}
            contextId="employment-categories"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/attendance/break-type",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <AttendenceBreakTypesList />,
      },
      {
        path: "add",
        element: <AttendenceBreakTypesForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <AttendenceBreakTypesForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <AttendenceBreakTypesForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_attendance_break_types"
            displayName="Attendance Break Type"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-break-type?mode=2`}
            contextId="attendance-break-types"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/leave/employee-leaves",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <EmployeeLeaveList />,
      },
      {
        path: "add",
        element: <EmployeeLeaveForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <EmployeeLeaveForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <EmployeeLeaveForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="employee_leaves"
            displayName="Employee Leaves"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employee-leave?mode=2`}
            contextId="employee-leaves"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/work-shift",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <WorkShiftList />,
      },
      {
        path: "add",
        element: <WorkShiftForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <WorkShiftForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <WorkShiftForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_work_shifts"
            displayName="Workshifts"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/workshift?mode=1`}
            contextId="work-shifts"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/location",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationLocationList />,
      },
      {
        path: "add",
        element: <OrganizationLocationForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationLocationForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <OrganizationLocationForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_locations"
            displayName="Locations"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/location?mode=2`}
            contextId="locations"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/business/division",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <BusinessDivisionsList />,
      },
      {
        path: "add",
        element: <BusinessDivisionForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <BusinessDivisionForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <BusinessDivisionForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_business_divisions"
            displayName="Organization Business Divisions"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/business-division?mode=2`}
            contextId="business-divisions"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/business/unit",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <BusinessUnitList />,
      },
      {
        path: "add",
        element: <BusinessUnitForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <BusinessUnitForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <BusinessUnitForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_business_units"
            displayName="Organization Business Units"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/business-unit?mode=2`}
            contextId="business-units"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/departments/locations",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationDepartmentsLocationList />,
      },
      {
        path: "add",
        element: <OrganizationDepartmentLocationsForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationDepartmentLocationsForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <OrganizationDepartmentLocationsForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_departments_locations"
            displayName="Organization Departments Locations"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/department-location?mode=2`}
            contextId="department-locations"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/employement/status",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationEmployementStatusesList />,
      },
      {
        path: "add",
        element: <OrganizationEmployementStatusesForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <OrganizationEmployementStatusesForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <OrganizationEmployementStatusesForm mode="view" />,
      },

      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_employement_statuses"
            displayName="Organization Employement Statuses"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employemnt-status?mode=2`}
            contextId="employement-statuses"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/holiday/holiday",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <HolidayList />,
      },
      {
        path: "add",
        element: <HolidayForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <HolidayForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <HolidayForm mode="view" />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_holidays"
            displayName="Organization Holidays"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/holiday?mode=2`}
            contextId="holidays"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },  
    ],
  },

  {
    path: "/employee/employee-contacts",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <EmployeeContactList />,
      },
      {
        path: "add",
        element: <EmployeeContactForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <EmployeeContactForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <EmployeeContactForm mode="view" />,
      },
    ],
  },

  {
    path: "/organization/system-modules",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <SystemModulesList />,
      },
      {
        path: "add",
        element: <SystemModulesForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <SystemModulesForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <SystemModulesForm mode="view" />,
      },
    ],
  },

  {
    path: "/organization/module-action",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ModuleActionList />,
      },
      {
        path: "add",
        element: <ModuleActionForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ModuleActionForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <ModuleActionForm mode="view" />,
      },
    ],
  },

  // Application Managment Routes
  {
    path: "/application/user-roles",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <UserRoleList />,
      },
      {
        path: "add",
        element: <UserRoleForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <UserRoleForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <UserRoleForm mode="view" />,
      },

      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="application_user_roles"
            displayName="Application User Roles"
            dataApi={`${MAIN_URL}/api/application/userrole?mode=2`}
            contextId="user-roles"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/application/user-modules",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <UserModuleList />,
      },
      {
        path: "add",
        element: <UserModuleForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <UserModuleForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <UserModuleForm mode="view" />,
      },
    ],
  },

  {
    path: "/application/user",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <UserList />,
      },
      {
        path: "add",
        element: <UserForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <UserForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <UserForm mode="view" />,
      },
    ],
  },

  {
    path: "/application/user-errorlogs",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ApplicationErrorLogList />,
      },
      {
        path: "add",
        element: <ApplicationErrorLogForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ApplicationErrorLogForm mode="edit" />,
      },
    ],
  },

  {
    path: "/organization/leave-policy",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LeavePolicyList />,
      },
      {
        path: "add",
        element: <LeavePolicyForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <LeavePolicyForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <LeavePolicyForm mode="view" />,
      },

      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_leave_policies"
            displayName="Organization Leave Policy"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/leave-policy?mode=2`}
            contextId="leave-policies"
            mode="personalize-view"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/application/user-role-assignment",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <RoleAssignmentList />,
      },
      {
        path: "add",
        element: <RoleAssignmentForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <RoleAssignmentForm mode="edit" />,
      },
       {
        path: "view/:id",
        element: <RoleAssignmentForm mode="view" />,
      },
    ],
  },

  {
    path: "/attendance",
    element: (
      <RouteProtector>
        <Attendance />
      </RouteProtector>
    ),
  },

  {
    path: "/login",
    element: <Login title={"Login"} />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword title={"Forgot Password"} />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword title={"Reset Password"} />,
  },
  // footer
  {
    path: "/features",
    element: <Features />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/cookies",
    element: <Cookies />,
  },
  {
    path: "/support",
    element: <Support />,
  },
  {
    path: "/system-status",
    element: <SystemStatus />,
  },
  {
    path: "/not-authorised",
    element: <NotAuthorized />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
]);






  export default function AppRouter() {
  const { userData } = useAuthStore();
  const org = userData?.organization;

  // Temporary diagnostic for invalid element type (remove after fix)
  const suspects = {
    Dashboard,
    RouteProtector,
    CoverLayout,
    PersonalizeDataGrid,
    PersonalizationModal,
    RouterProvider,
  };
  for (const [name, Comp] of Object.entries(suspects)) {
    const t = typeof Comp;
    const valid =
      t === "function" ||
      t === "string" ||
      (Comp != null &&
        typeof Comp === "object" &&
        (Comp.$$typeof != null || typeof Comp.render === "function"));
    if (!valid) {
      const keys =
        Comp && typeof Comp === "object" ? Object.keys(Comp).slice(0, 12) : [];
      throw new Error(
        `[AppRouter] Invalid element type for ${name}: typeof=${t}, keys=${JSON.stringify(
          keys
        )}, hasDefault=${Boolean(Comp && Comp.default)}`
      );
    }
  }

  return <RouterProvider router={router(org)} />;
}
